import { cn } from "@/lib/utils";
import type { TaskStatus } from "@/lib/tasks/queries";

import { TaskStatusIcon } from "./task-status-icon";
import {
  TASK_KANBAN_COLUMN_HEADER_BG,
  TASK_KANBAN_COLUMN_TITLES,
  TASK_KANBAN_COLUMN_TOP_RADIUS_CLASS,
} from "./task-kanban-styles";

type Props = {
  status: TaskStatus;
  title?: string;
  count: number;
  /** Center the title in the column header (icon left, count right). */
  centerTitle?: boolean;
};

export function TaskKanbanColumnHeader({
  status,
  title,
  count,
  centerTitle = false,
}: Props) {
  const label = title ?? TASK_KANBAN_COLUMN_TITLES[status];

  return (
    <div
      className={cn(
        "flex h-12 shrink-0 items-center px-4 pt-1",
        centerTitle ? "grid grid-cols-3 gap-3" : "gap-3",
        TASK_KANBAN_COLUMN_TOP_RADIUS_CLASS,
        TASK_KANBAN_COLUMN_HEADER_BG[status],
      )}
    >
      <TaskStatusIcon status={status} size={16} aria-hidden />
      <h2
        className={cn(
          "min-w-0 font-body-s-book text-neutral-11",
          centerTitle ? "text-center" : "flex-1",
        )}
      >
        {label}
      </h2>
      <span
        className={cn(
          "font-caption-1-regular text-neutral-07",
          centerTitle && "text-right",
        )}
      >
        {count}
      </span>
    </div>
  );
}
